<template>
    <BLink @click.prevent="downloadFile" class="mr-2">
        <i :class="icon" v-if="icon"/>
        <span class="small" :class="{'ml-3': icon !== null}" v-if="text || name">{{ text || name }}</span>
    </BLink>
</template>

<script>
export default {

    props: {
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: false,
            default: '',
        },
        text: {
            type: String,
            required: false,
            default: null,
        },
    },

    methods: {

        downloadFile() {
            this.$store.dispatch('attachment/downloadAttachment', {
                id: this.id,
                name: this.name
            })
                .catch((error) => {
                    this.errorMessage(error.response.status === 404 ? 'Soubor nebyl nalezen.' : 'Nepodařilo se stáhnout soubor')
                })
        },

    },

}
</script>
